import { module as BaseModule } from 'modujs';
import Packery from 'packery';
import imagesLoaded from 'imagesloaded';

export default class extends BaseModule {
  constructor(m) {
    super(m);
    this.pckry = null;
    this.observer = null;
  }

  init() {
    const el = this.el;

    if (!el) return;

    // Inicializar masonry
    this.initPackery();

    // Configurar el observer
    this.observer = new MutationObserver((mutations) => {
      const hasNewNodes = mutations.some(mutation => 
        mutation.type === 'childList' && mutation.addedNodes.length > 0
      );

      if (hasNewNodes) {
        // Esperar a que las imágenes se carguen
        imagesLoaded(el, { background: true }, () => {
          // Obtener los nuevos elementos
          const newItems = mutations
            .flatMap(m => Array.from(m.addedNodes))
            .filter(node => node.classList?.contains('paper-card'));

          if (newItems.length > 0) {
            // Añadir los nuevos elementos a Packery
            this.pckry.appended(newItems);
            
            // Asegurarse de que las imágenes están cargadas antes de hacer layout
            imagesLoaded(newItems).on('progress', () => {
              this.pckry.layout();
            });
          }
        });
      }
    });

    // Comenzar a observar
    this.observer.observe(el, {
      childList: true,
      subtree: false
    });

    // Escuchar evento de recarga desde el módulo more
    el.addEventListener('masonry:reload', () => {
      // Esperar un momento para que el DOM se actualice
      setTimeout(() => {
        if (this.pckry) {
          this.pckry.destroy();
        }
        this.initPackery();
      }, 100);
    });
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.pckry) {
      this.pckry.destroy();
    }
  }

  initPackery() {
    const el = this.el;

    this.pckry = new Packery(el, {
      itemSelector: '.paper-card',
      percentPosition: true,
      gutter: '.grid-gap',
      originLeft: true,
      horizontalOrder: true,
    });

    // Espera a que todas las imágenes se carguen
    imagesLoaded(el, { background: true }, () => {
      this.pckry.layout();
    });

    // Reajustar el layout progresivamente mientras las imágenes se cargan
    imagesLoaded(el).on('progress', () => {
      this.pckry.layout();
    });

    // Fallback: forzar otro layout después de 1 segundo por si hay GIFs lentos o CDN
    setTimeout(() => {
      this.pckry.layout();
    }, 1000);
  }
}
